<template> 
  <div class='px-3 py-3 mb-5 col-24 col-md-11'>
    <div class='col d-column'>
      <Invoices :menuItem.sync="menuItem" />
    </div> 
  </div>  
</template>

<script>
 import Invoices from '../company/invoice'
export default { 
  components:{
    Invoices
  },
  data() {
    return { 
      menuItem: 'bounties',
    };
  },
  mounted() { 
  },
  methods: {
    async alterItens() {
       
    },
  },
};
</script> 